<template>

  <div class="autocomplete d-flex align-center">
    <v-autocomplete :value="value"
                    @input="$emit('input', $event)"
                    :items="assets"
                    :label="_label"
                    :menu-props="{ auto: true }"
                    :disabled="disabled"
                    item-text="fullPath"
                    item-value="id"
    />

    <div class="icon" v-if="value">
      <v-btn text icon @click="clear()" v-if="clearable">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'asset-autocomplete',

    props: [ 'value', 'label', 'clearable', 'disabled' ],

    data () {
      return {
        assets: []
      }
    },

    computed: {
      _label () {
        return this.label || this.$t('entityNames.assets')
      }
    },

    methods: {
      clear () {
        this.$emit('input', null)
      }
    },

    async created () {
      if (!this.$store.state.items['assets'].length)
        await this.$store.dispatch('getItems', { model: { name: 'assets' } })

      this.assets = this.$store.state.items['assets']
    },
  }

</script>

<style lang="scss" scoped>

</style>
